import React from "react";
import 'react-phone-number-input/style.css';
import {ActivityHeaderDisplay} from "./ActivityHeaderDisplay";
import {ActivityBrokerAssignmentForm} from "./ActivityBrokerAssignmentForm";
import {PillButton} from "../common/PillButton";
import {ConfirmDeleteButton} from "../common/ConfirmDeleteButton";

export let RequestedActivityForm = function (props: any) {
    const activity = props.activity;
    const formEngine = props.formEngine;
    const activityBrokerAssignmentsDisplay = []
    let assignedAmount = 0;

    for (let i = 0; i < activity.activity_broker_assignments.length; i++) {
        let activityBrokerAssignment = activity.activity_broker_assignments[i];
        let assignmentHeader = null;
        let deleteActivityButton = null;
        let addActivityBrokerAssignmentButton = null;
        let showAddBrokerButton = (i === (activity.activity_broker_assignments.length - 1));
        let showDeleteActivityButton = (formEngine.dataStore.data().activities.length > 1) && (i === activity.activity_broker_assignments.length - 1);
        if (activityBrokerAssignment.assigned_material_amount > 0) {
            assignedAmount += parseFloat(activityBrokerAssignment.assigned_material_amount);
        }
        if (i > 0) {
            assignmentHeader = (
                <div className="activity-broker-assignment-header">
                    <div className="activity-broker-assignment-header-label">
                        {`BROKER ${i + 1}`}
                    </div>
                    <img
                        src="/static/images/trash-red.svg"
                        className="activity-broker-assignment-remove-icon"
                        onClick={() => props.deleteActivityBrokerAssignment(props.index, i)}
                    />
                    <div className="activity-broker-assignment-header-divider"></div>
                </div>
            )
        }
        if (showAddBrokerButton) {
            addActivityBrokerAssignmentButton = (
                <PillButton
                    buttonText="ADD BROKER"
                    onClick={() => props.addActivityBrokerAssignment(props.index)}
                    containerClasses="add-activity-broker-assignment-button-container"
                    buttonClasses="add-activity-broker-assignment-button"
                    rightIconSrc="/static/images/plus-for-button-white.svg"
                />
            )
        }
        if (showDeleteActivityButton) {
            deleteActivityButton = (
                <ConfirmDeleteButton
                    iconSrc="/static/images/trash-red.svg"
                    confirmingIconSrc="/static/images/trash-white.svg"
                    confirmText="CONFIRM ACTIVITY DELETION"
                    onConfirm={() => props.deleteActivity(props.index)}
                />
            )
        }

        activityBrokerAssignmentsDisplay.push(
            <div
                key={i}
                className="activity-broker-assignment"
            >
                {assignmentHeader}
                <ActivityBrokerAssignmentForm
                    getKnownAssignedTruckCountForBrokerId={props.getKnownAssignedTruckCountForBrokerId}
                    activityBrokerAssignmentIndex={i}
                    activityIndex={props.index}
                    activity={activity}
                    activityBrokerAssignment={activityBrokerAssignment}
                    formEngine={formEngine}
                    onChangeActivityBrokerAssignmentValue={props.onChangeActivityBrokerAssignmentValue}
                    onChangeActivityBrokerAssignmentPitHaul={props.onChangeActivityBrokerAssignmentPitHaul}
                    forceActivityBrokerAssignmentValueToInteger={props.forceActivityBrokerAssignmentValueToInteger}
                    forceActivityBrokerAssignmentValueToFloat={props.forceActivityBrokerAssignmentValueToFloat}
                />
                <div className="activity-broker-assignment-options">
                    <div className="activity-broker-assignment-options-content">
                        <div className="activity-broker-assignment-options-left">
                            <div className="activity-broker-assignment-options-left-content">
                                {addActivityBrokerAssignmentButton}
                            </div>
                        </div>
                        <div className="activity-broker-assignment-options-right">
                            <div className="activity-broker-assignment-options-right-content">
                                {deleteActivityButton}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="activity-form">
            <ActivityHeaderDisplay
                activity={activity}
                displayIndex={props.index + 1}
            />
            {activityBrokerAssignmentsDisplay}
            <div className="activity-form-final-row-divider"/>
            <div className="activity-form-final-row-container">
                <div className="activity-form-final-row">
                    <div className="common-form-field activity-purchase-order-field">
                        <div className="common-form-field-label">Activity Purchase Order #</div>
                        <div className="common-form-field-input-container">
                            <input
                                type="text"
                                className="common-form-input"
                                value={activity.purchase_order_number || ''}
                                onChange={(event) => props.onChangeActivityValue(
                                    props.index,
                                    'purchase_order_number',
                                    event.target.value.replace(/[^A-Za-z0-9-]/g, '').slice(0, 15)
                                )}
                            />
                        </div>
                    </div>
                    <div className="total-material-assigned-section">
                        <div className="total-material-assigned-text">
                            <span className="total-material-assigned-label">Total Material Assigned:</span>
                            <span className="total-material-assigned-amount">
                                {` ${assignedAmount} of ${activity.requested_material_amount} ${activity.requested_activity_material ? activity.requested_activity_material.measurement_unit + 's' : ''}`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
